import { css, unsafeCSS } from 'lit';
import { sbkCoreBreakpointLg, sbkCoreBreakpointMd } from "@/tokens/variables";

const breakpointMaxWidthMd = unsafeCSS(`calc(${sbkCoreBreakpointMd} - 1px)`);
const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const checkboxGroupStyles = css`
  
    :host {
      --_checkbox__margin-bottom: 0;
    }

    .checkbox-group {
        border: none;
        margin: 0 0 var(--sbkCoreSpacingMd) 0;
        padding: 0;

        .label__wrapper + sbk-annotation {
            margin-top: calc(var(--sbkInput3xs) * -1);
            margin-bottom: var(--sbkInput3xs);
        }
    }

    .checkbox-slot {
        display: flex;
        flex-direction: column;
        gap: var(--sbkCoreSpacing2xs);

        @media all and (max-width: ${breakpointMaxWidthMd}) {
            margin-bottom: var(--sbkInput3xs);
        }
    }

    @media all and (min-width: ${breakpointLg}) {
        .checkbox-group--horizontal .checkbox-slot {
            flex-direction: row;
            gap: var(--sbkCoreSpacingXsBase);
        }
    }
`;
